import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { ExamTemplateEditModal } from 'components';

import { CtExamTemplateEdit, CtExamTemplateDelete, CtExamTemplateCopy } from 'containers';

import * as commonVar from 'libs/commonVar';

import classNames from 'classnames/bind';
import styles from './ExamTemplateInTableMenu.css';
const cx = classNames.bind(styles);

class ExamTemplateInTableMenu extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false,
      editModal: false,
      copyModal: false
    };
  }

  mountDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  mountCopyModal = () => {
    this.setState({ copyModal: !this.state.copyModal });
  };

  mountEditModal = () => {
    this.setState({ editModal: !this.state.editModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal, copyModal, editModal } = this.state;
    const { isAuth, templateInfo } = this.props;
    const { mountDeleteModal, mountCopyModal, mountEditModal } = this;

    const { templateNo, serviceTemplateNo, serviceNo } = templateInfo;

    return (
      <div className={'inline-conf-area'}>
        <Tooltip
          title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_1', defaultMessage: '템플릿 복제' }))}
          placement="bottom">
          <Icon color="grey" className={cx('icon-copy')} name="copy" link onClick={mountCopyModal} />
        </Tooltip>
        {copyModal && (
          <CtExamTemplateCopy isAuth={isAuth} templateInfo={templateInfo} mountCopyModal={mountCopyModal} />
        )}
        {isAuth !== 2 &&
          !!!serviceTemplateNo && (
            <Tooltip
              title={defineMessages(
                formatMessage({ id: 'ExamTemplateInTableMenu_2', defaultMessage: '템플릿 상세 보기' })
              )}
              placement="bottom">
              <Icon color="grey" className={cx('icon-edit')} name="file text outline" link onClick={mountEditModal} />
            </Tooltip>
          )}
        {((isAuth === 2 && commonVar.isSaas === 1) || serviceTemplateNo) && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_3', defaultMessage: '템플릿 수정' }))}
            placement="bottom">
            <Icon color="grey" className={cx('icon-edit')} name="edit" link onClick={mountEditModal} />
          </Tooltip>
        )}
        {editModal && (
          <ExamTemplateEditModal isAuth={isAuth} templateInfo={templateInfo} mountEditModal={mountEditModal} />
        )}
        {((commonVar.isGs !== 1 && isAuth === 2) || serviceTemplateNo) && (
          <Tooltip
            title={defineMessages(formatMessage({ id: 'ExamTemplateInTableMenu_4', defaultMessage: '템플릿 삭제' }))}
            placement="bottom">
            <Icon color="grey" className="icon-remove" name="remove circle" link onClick={mountDeleteModal} />
          </Tooltip>
        )}
        {((commonVar.isGs !== 1 && isAuth === 2) || serviceTemplateNo) &&
          deleteModal && (
            <CtExamTemplateDelete isAuth={isAuth} templateInfo={templateInfo} mountDeleteModal={mountDeleteModal} />
          )}
      </div>
    );
  }
}

ExamTemplateInTableMenu.propTypes = {
  //
};
ExamTemplateInTableMenu.defaultProps = {
  //
};

export default injectIntl(ExamTemplateInTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateInTableMenu.js